import { configureStore, Middleware } from '@reduxjs/toolkit';

// Reducers
import projectReducer from '@/features/project/projectSlice';
import portfolioReducer from '@/features/portfolio/portfolioSlice';

// Logger
const loggerMiddleware: Middleware = (storeAPI) => (next) => (action) => {
  // console.log('Dispatching:', action);
  const result = next(action);
  // console.log('New State:', storeAPI.getState());
  return result;
};

export const store = configureStore({
  reducer: {
    project: projectReducer,
    portfolio: portfolioReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable the check
    }).concat(loggerMiddleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
